export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="w-full px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/60 text-primary-700 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              聚合西瓜·樱花·糖豆·樱桃视频
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
              糖心视频 — 热门影视
              <br className="hidden sm:block" />
              高清免费在线观看平台
            </h1>

            <p className="mt-3 text-base md:text-lg text-primary-500 font-heading font-medium">
              最新电影电视剧综艺，不缓冲畅快追剧
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              糖心视频网汇聚西瓜视频、樱花视频、糖豆视频、樱桃视频等热门平台海量资源，涵盖最新电影、热播电视剧、人气综艺节目、高分纪录片及番剧动漫。每日持续更新，高清画质流畅播放，无需注册即可免费在线观看，是您一站式追剧观影的首选平台。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-accent-100/70">
                <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
                <span className="text-xs md:text-sm text-accent-800 font-medium whitespace-nowrap">每日更新3000+部</span>
              </div>
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-secondary-100/70">
                <i className="ri-global-line text-secondary-600 text-sm"></i>
                <span className="text-xs md:text-sm text-secondary-800 font-medium whitespace-nowrap">覆盖10+热门平台</span>
              </div>
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-accent-100/70">
                <i className="ri-hd-line text-accent-600 text-sm"></i>
                <span className="text-xs md:text-sm text-accent-800 font-medium whitespace-nowrap">1080P高清画质</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#app"
                onClick={(e) => handleScroll(e, '#app')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 font-medium text-sm md:text-base hover:bg-background-100 hover:border-foreground-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] md:aspect-[16/10] lg:aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20collage%20featuring%20floating%20film%20reels%2C%20theater%20curtains%20in%20rich%20crimson%20red%2C%20soft%20golden%20spotlight%20beams%2C%20movie%20clapperboard%2C%20and%20abstract%20geometric%20shapes%20in%20warm%20amber%20and%20rose%20tones%2C%20modern%20minimalist%20poster%20style%20with%20clean%20composition%2C%20dark%20background%20with%20dramatic%20lighting%2C%20luxurious%20entertainment%20vibe&width=960&height=720&seq=hero-cinema-visual&orientation=landscape"
                alt="糖心视频 - 热门影视高清在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/15 via-transparent to-accent-500/15"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-100/60 to-transparent pointer-events-none"></div>
    </section>
  );
}